import React from 'react';

import "./contact.css"
import {SEO} from "../../components/SEO";

function Index() {
    return (
        <div className="contact">
            <SEO isDefault />
            <div className={"label"}>サイト・漫画・お仕事に関するお問い合わせ</div>
            <div className={"info text-3xl lg:text-6xl mb-16"}><a href="mailto:hisayasahi@gmail.com">hisayasahi@gmail.com</a></div>

            <div className={"label"}>Twitterからでも大丈夫です！</div>
            <div className={"info text-3xl lg:text-6xl"}><a href="https://twitter.com/hisayasahi">@hisayasahi</a></div>
        </div>
    );
}

export default Index;